import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './CategoryTiles.css';
import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM, get } from '../../utils';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import { CategoryTilesCard } from './components/CategoryTilesCard';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
var CategoryTiles = function CategoryTiles(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  if (!fields || !fields.data || !fields.data.datasource) {
    console.info('CategoryTiles component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [CategoryTiles component is empty: please provide data source]");
    }
    return null;
  }
  var hasTitle = Boolean(get(fields, 'data.datasource.title.jss.value'));
  var title = get(fields, 'data.datasource.title.jss');
  var hasShortDescription = Boolean(get(fields, 'data.datasource.shortDescription.jss.value'));
  var shortDescription = get(fields, 'data.datasource.shortDescription.jss');
  var childrenItems = get(fields, 'data.datasource.carousel.values', []);
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var analyticsCarouselButtonHandler = function analyticsCarouselButtonHandler(text) {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['RightOrLelftAnalytics'], params), text);
  };
  var renderItems = function renderItems() {
    return childrenItems.map(function (item, index) {
      return /*#__PURE__*/React.createElement("a", {
        "aria-label": "Category Tiles Card",
        "aria-labelledby": "Category Tiles Card",
        href: item.navigationButton.jss.value.href,
        key: item.id
      }, /*#__PURE__*/React.createElement(CategoryTilesCard, {
        item: item,
        eventsAnalytics: eventsAnalytics,
        params: params,
        index: index
      }));
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "categoryTilesWrapper"
  }, /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref2) {
    var renderCarousel = _ref2.renderCarousel,
      renderPreviousButton = _ref2.renderPreviousButton,
      renderNextButton = _ref2.renderNextButton,
      renderProgressBar = _ref2.renderProgressBar;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "textWithButtons"
    }, hasTitle && /*#__PURE__*/React.createElement(Text, {
      tag: "h3",
      className: "h3 h__title",
      field: title
    }), /*#__PURE__*/React.createElement("div", {
      className: "btn-group"
    }, renderPreviousButton(function () {
      return analyticsCarouselButtonHandler("left");
    }), renderNextButton(function () {
      return analyticsCarouselButtonHandler("right");
    }))), /*#__PURE__*/React.createElement("div", {
      className: "card-container__inner"
    }, renderCarousel(renderItems(), {
      responsive: {
        extra: {
          breakpoint: {
            max: 10000,
            min: 1601
          },
          items: 5
        },
        desktop: {
          breakpoint: {
            max: 1600,
            min: 901
          },
          items: 4
        },
        tablet: {
          breakpoint: {
            max: 900,
            min: 701
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 700,
            min: 0
          },
          items: 1
        }
      },
      containerClass: "carouselContainer"
    }), /*#__PURE__*/React.createElement("div", {
      className: "progressBar"
    }, renderProgressBar())));
  }))));
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "cx9sz1p";
var rtlStyles = "r13lez2t";
var ltrStyles = "lzl2ejj";
export default CategoryTiles;